
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"44"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.182 44A2.19 2.19 0 010 41.8V6.6a2.191 2.191 0 012.182-2.2h6.545v4.4H4.363v30.8h39.274V8.8h-4.364V11a2.182 2.182 0 11-4.363 0V2.2a2.182 2.182 0 114.363 0v2.2h6.545A2.191 2.191 0 0148 6.6v35.2a2.19 2.19 0 01-2.182 2.2zm19.636-11A2.182 2.182 0 1124 35.2a2.191 2.191 0 01-2.182-2.2zM10.91 33a2.182 2.182 0 112.182 2.2A2.19 2.19 0 0110.91 33zm21.818-8.8a2.182 2.182 0 112.182 2.2 2.191 2.191 0 01-2.181-2.2zm-10.91 0A2.182 2.182 0 1124 26.4a2.192 2.192 0 01-2.182-2.2zm-10.908 0a2.182 2.182 0 112.182 2.2 2.191 2.191 0 01-2.182-2.2zM13.092 11V2.2a2.182 2.182 0 114.363 0v2.2h13.092v4.4H17.455V11a2.182 2.182 0 11-4.363 0z","fill":"#fff"}})])
          )
        }
      }
    